import React, { useEffect } from 'react';
import { getFramework, useIdentity } from '@/framework';
import type { ShortcutMenu } from '@/plugins/shortcut-menu/shortcut-menu';
import { PluginType, type IExportPlugin } from '@/version-types';
import { imageFormatBrushShortcutItem } from './image-format-brush-item';
import { imageLayerAiShortcutItem } from './image-layer-ai';

const ImageLayerShortcutMenuView: React.FC = React.memo(() => {
    const identity = useIdentity();

    useEffect(() => {
        const framework = getFramework(identity);

        framework.service.registration.getInstance<ShortcutMenu>('ShortcutMenu').addItems([
            {
                key: 'image-layer-ai-60',
                sort: 60,
                render: imageLayerAiShortcutItem,
            },
            {
                key: 'image-format-brush-100',
                sort: 100,
                render: imageFormatBrushShortcutItem,
            },
        ]);
    }, [identity]);

    return null;
});

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 1,
    name: 'image-layer-shortcut-menu',
    render() {
        return <ImageLayerShortcutMenuView />;
    },
};

export default exportPlugin;
